import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import { ContainerTypeDeliveryChargeRulesDeleteResponseType } from "@sellar-io/api-v2/types";

export const useContainerTypeDeliveryChargeRulesDelete = (
  containerTypeDeliveryChargeRulesId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `container-type-delivery-rules/${containerTypeDeliveryChargeRulesId}`,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as ContainerTypeDeliveryChargeRulesDeleteResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.FulfillmentType],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.FulfillmentType],
      });
    },
  });
};
